import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { GearIcon } from '@phosphor-icons/react';
import { Breadcrumb } from '../components/Breadcrumb';

export const SettingsPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <Breadcrumb items={[{ label: t('app.nav.settings') }]} />
      <div className="mc-heading">
        <div>
          <h1>{t('settingsPage.title')}</h1>
          <p>{t('settingsPage.subtitle')}</p>
        </div>
      </div>
      <section className="mc-card mc-state">
        <div className="mc-state__icon">
          <GearIcon size={46} weight="duotone" />
        </div>
        <h2>{t('settingsPage.construction')}</h2>
        <p>{t('settingsPage.constructionText')}</p>
        <div className="mc-actions">
          <Link to="/" className="mc-btn mc-btn--outline">
            {t('settingsPage.back')}
          </Link>
        </div>
      </section>
    </>
  );
};
